import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import axios from "axios";
import { handleApiError } from "@utils/errorHandler";
import { Dialog, Button, Image } from "hesus-ui-kit";
import PulseLoader from "react-spinners/PulseLoader";
import { ColumnButton } from "@utils/extra-style";
import Header from "./components/Header";
import DisputeContent from "./components/DisputeContent";

import {
  HeaderWrapper,
  Title,
  ButtonWrapper,
  FormBody,
  FlexRow,
  SectionContainer,
  GridRow,
  GridSubItem,
  NewDisputeButtonWrapper,
} from "./DisputeView.styled";
import closeIcon from "@icons/ic-close-white.svg";

const DisputeView = (props) => {
  const {
    t,
    planningId,
    siteId,
    onClose,
    updateDisputeRefeshStatus,
    onDisputeAdd,
    onDisputeEdit,
  } = props;

  const [isLoading, setIsLoading] = useState(false);
  const [disputeData, setDisputeData] = useState([]);
  const [refreshDisputeData, seRefreshDisputeData] = useState(false);

  const fetchDisputeData = () => {
    setIsLoading(true);
    axios
      .get(`/disputes?lineGroupId=${planningId}`)
      .then((response) => {
        if (response.data?.disputes) {
          setDisputeData(response.data?.disputes);
          setIsLoading(false);
        }
      })
      .catch((error) => handleApiError(error));
  };

  useEffect(() => {
    fetchDisputeData();
  }, []);

  useEffect(() => {
    if (refreshDisputeData) {
      seRefreshDisputeData(false);
      fetchDisputeData();
    }
  }, [refreshDisputeData]);

  return (
    <>
      <Dialog width="65rem">
        <div className="add-edit-dispute">
          <HeaderWrapper>
            <Title>{t("GLOBAL_DISPUTES_TITLE")}</Title>
            <Button
              onClick={onClose}
              styles={{
                backgroundColor: "transparent",
                border: "none",
                height: "auto",
                padding: 0,
                "&:hover": {
                  backgroundColor: "transparent",
                },
              }}
            >
              <Image
                src={closeIcon}
                alt="close Product price popup"
                styles={{ height: "25px", cursor: "pointer" }}
              />
            </Button>
          </HeaderWrapper>
          <FormBody>
            <FlexRow>
              <SectionContainer>
                <div>
                  <GridRow marginTop="0px">
                    <NewDisputeButtonWrapper>
                      <ColumnButton
                        border="#1bace4"
                        background="#1bace4"
                        padding="5px"
                        onClick={() => onDisputeAdd(planningId, siteId)}
                      >
                        {t("NEW_DISPUTE")}
                      </ColumnButton>
                    </NewDisputeButtonWrapper>
                  </GridRow>
                  {isLoading && (
                    <div className="suggestions-list-loading">
                      <PulseLoader color="#1bace4" size={15} />
                    </div>
                  )}

                  {!isLoading &&
                    disputeData?.length > 0 &&
                    disputeData.map((dispute, disputeIndex) => {
                      return (
                        <React.Fragment
                          key={`supplier-dispute-list-${dispute.id}${disputeIndex}`}
                        >
                          <Header
                            data={dispute}
                            indexCount={disputeIndex}
                            seRefreshDisputeData={seRefreshDisputeData}
                            updateDisputeRefeshStatus={
                              updateDisputeRefeshStatus
                            }
                            onDisputeEdit={onDisputeEdit}
                          />
                          <DisputeContent data={dispute} />
                        </React.Fragment>
                      );
                    })}
                  {!isLoading && disputeData?.length === 0 && (
                    <GridRow>
                      <GridSubItem
                        fontStyle="italic"
                        fontSize="16px"
                        color="#fff"
                        alignContent="center"
                      >
                        {t("NO_DISPUTES")}
                      </GridSubItem>
                    </GridRow>
                  )}
                </div>
              </SectionContainer>
            </FlexRow>
          </FormBody>

          <ButtonWrapper>
            <Button
              styles={{
                color: "#333",
                background: "#fff",
                marginRight: "0.32rem",
                border: "1px solid #ccc",
                "&:hover": {
                  backgroundColor: "#ccc",
                },
              }}
              onClick={onClose}
            >
              {t("CLOSE")}
            </Button>
          </ButtonWrapper>
        </div>
      </Dialog>
    </>
  );
};

DisputeView.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.number,
};

DisputeView.defaultProps = {
  id: null,
};

export default withTranslation()(DisputeView);
